import type {ErrorResponse} from "./game.flow.types";

export const SET_LAUNCH_ERROR = "casino-game/SET_LAUNCH_ERROR";

export type SetLaunchErrorAction = {
    type: typeof SET_LAUNCH_ERROR;
    payload: string;
};

export type GameActions = SetLaunchErrorAction;

export const setLaunchError = (error: ErrorResponse): SetLaunchErrorAction => ({
    type: SET_LAUNCH_ERROR,
    payload: error,
});
